export function track(event, event_name) {
    if(! window.dataLayer) {
        return console.error('window.dataLayer is undefined - Is GTM enabled?');
    }

    try {
        if (window.dataLayer && Array.isArray(window.dataLayer)) {

            if(typeof event_name === 'string') {
                window.dataLayer.push({
                    event,
                    event_name,
                });
            } else if(typeof event_name === 'object') {
                window.dataLayer.push({
                    event,
                    ...event_name,
                });
            }
        }

        if (window.location.hostname === 'localhost') {
            console.info(window.dataLayer);
        }
    } catch(e) {
        console.error('Tracking error', e);
    }
}



// WEBPACK FOOTER //
// ./src/tracking.js